import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { MapPin, Package, BadgeCheck } from "lucide-react";
import { bannerBackground, accentColor } from "@/lib/theme";

export default function ShopCard({ shop }) {
  const banner = shop.banner_url ? fileUrl(shop.banner_url) : null;
  const accent = accentColor(shop);
  return (
    <Link
      to={`/shop/${shop.username}`}
      className="cp-card overflow-hidden flex flex-col hover:-translate-y-0.5 hover:shadow-lg transition group"
      data-testid={`shop-card-${shop.username}`}
      style={{ ["--shop-accent"]: accent }}
    >
      <div
        className="h-32 relative"
        style={{ background: bannerBackground(shop, banner) }}
      >
        {shop.preview_images.length > 0 && (
          <div className="absolute inset-0 grid grid-cols-3 gap-0.5 opacity-90">
            {shop.preview_images.map((img, i) => (
              <div
                key={i}
                className="bg-cover bg-center"
                style={{ backgroundImage: `url('${fileUrl(img)}')` }}
              />
            ))}
          </div>
        )}
      </div>

      <div className="p-4 flex-1 flex flex-col">
        <div className="flex items-start gap-3 -mt-10">
          <Avatar className="w-14 h-14 border-4 border-white shadow-sm shrink-0">
            <AvatarImage src={fileUrl(shop.avatar_url)} />
            <AvatarFallback className="text-white font-heading text-lg font-bold" style={{ background: accent }}>
              {shop.business_name?.slice(0, 2).toUpperCase()}
            </AvatarFallback>
          </Avatar>
        </div>

        <h3 className="mt-3 font-heading text-xl font-semibold text-[#3B2C24] leading-tight transition" style={{ color: undefined }}>
          <span className="group-hover:text-[color:var(--shop-accent)] transition">{shop.business_name}</span>
          {shop.verified && (
            <BadgeCheck
              className="inline-block ml-1.5 w-4 h-4 align-[-2px]"
              style={{ color: "#2F80ED", fill: "#EAF1FB" }}
              aria-label="Verified seller"
              data-testid={`verified-badge-${shop.username}`}
            />
          )}
        </h3>
        <div className="text-xs text-[#857163] mt-0.5">@{shop.username}</div>

        {shop.tagline && (
          <p className="mt-2 text-sm text-[#3B2C24] italic line-clamp-2">
            "{shop.tagline}"
          </p>
        )}

        <div className="mt-auto pt-3 flex items-center justify-between text-xs text-[#857163]">
          {shop.city ? (
            <span className="inline-flex items-center gap-1 truncate">
              <MapPin className="w-3 h-3 shrink-0" /> {shop.city}
            </span>
          ) : (
            <span />
          )}
          <span className="inline-flex items-center gap-1 shrink-0">
            <Package className="w-3 h-3" />
            {shop.product_count} {shop.product_count === 1 ? "listing" : "listings"}
          </span>
        </div>
      </div>
    </Link>
  );
}
